
import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "../../store";
import { debugData } from "../../utils/debugData";
import { isEnvBrowser } from "../../utils/misc";
import { useSocketEventOutsideRequest } from "../../hooks/useSocketEventOutsideRequest";
import { socketRequest } from "../../utils/socketRequest";

import { UserState, SET_PLAYERDATA } from "../../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA, DEV_SET_autoPayAccount } from "../../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden, SET_selectedAccount } from "../../reducers/uiReducer";

import DropDown from "../GlobalComponents/Dropdown/Dropdown";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid, regular, light, thin, duotone, brands } from "@fortawesome/fontawesome-svg-core/import.macro";


import moment from 'moment';
import { throttle } from 'lodash';

const AccountSelection: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    /** handles if auto pay is on */
    const isAutoPayOn = hardmoneyData.autoPayAccount !== "";

    // Calculate selectedAccount based on conditions
    const selectedAccount = isAutoPayOn
    ? hardmoneyData.autoPayAccount 
    : playerData.bankAccounts[0];

    /** handes if the dropdown is open or not mainly for caret svg*/
    const [isBankDropdownOpen, setisBankDropdownOpen] = useState<boolean>(false);


    // Dispatch action to update selectedAccount in UI state
    useEffect(() => {
        dispatch(SET_selectedAccount(selectedAccount));
      }, [dispatch, hardmoneyData, playerData, selectedAccount]);

    const fetchHouseData = useCallback(
        throttle(async (payAccount: string) => {
          try {
            const res: HardMoneyState = await socketRequest("ChangePayAccount", {
                houseID: hardmoneyData.houseID,
                houseOwner: hardmoneyData.houseOwner,
                payAccount: payAccount,
            }, hardmoneyData);

            if (res) {
                if (isEnvBrowser()) {
                    //console.log("SET NEW PAY ACCOUNT", res);
                    dispatch(DEV_SET_autoPayAccount(payAccount));
                } else {
                    dispatch(SET_HOUSEDATA(res));
                };
            } else {
              throw new Error("Invalid pay data received.");
            }
          } catch (err) {
            console.error("Error paydata house data:", err);
          } finally {
            //console.log("set");
          }
        }, 3000),
        [dispatch] 
    );
      

    const selectDropdownOption = (option: string) => {
      //console.log(option);
      if (uiData.selectedAccount !== option) {
        dispatch(SET_selectedAccount(option));

        // if auto pay is on and your accounts have the option you chose
        if (isAutoPayOn && playerData.bankAccounts.includes(option)) {
            //console.log("update server with new set account");
            fetchHouseData(option);
        }
      };

    };
    
    const handleDropdownChange = (e: boolean) => {
        //soundEffect('click2');
        setisBankDropdownOpen(e);
       //console.log(e, isBankDropdownOpen);
    };

    return (
        <div
            className="flexCenter"
            style={{
                width: "100%",
                //height: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
                position: "relative",
                border: "0.2vh solid rgba(90, 90, 90, 0.8)",
                borderRadius: "0.5vh",
                //backgroundColor: "yellow",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                padding: "3vh",
                fontSize: "1.5vh",
            }}
        >
            <div
                style={{
                    width: "100%",
                    //background: "pink",
                    color: "rgba(255, 255, 255, 0.8)",
                    display: "flex",
                    paddingBottom: "1vh",
                }}
            >
                This will be the account used for auto pay and payments
            </div>
            <div
                style={{
                    width: "100%",
                    display: "flex",
                }}
            >
                Bank Account:
            </div>
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "0.2vh solid rgba(90, 90, 90, 0.8)",
                    borderRadius: "0.5vh",
                    boxSizing: "border-box",
                    padding: "0.5vh",
                    //backgroundColor: "orange",
                }}
            >
                <DropDown
                    options={playerData.bankAccounts} 
                    onSelect={(e) => selectDropdownOption(e)} 
                    setIsMenuOpen={(e) => handleDropdownChange(e)} 
                    hoverColor="rgba(0, 0, 0, 0.25)"
                    backgroundColor="rgb(56, 56, 56)"
                >

                    <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "flex-start",
                                    height: "100%",
                                    //backgroundColor: "red",
                                    width: "100%",
                                    fontSize: "1.5vh",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                }}
                            >
                                <div
                                    style={{
                                        width: "100%",
                                        //height: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        //borderBottom: "0.1vh solid rgba(255, 255, 255, 0.9)",
                                        color: "rgba(255, 255, 255, 0.9)",
                                        gap: "3.5vh",
                                    }}
                                >
                                    {uiData.selectedAccount}

                                    <FontAwesomeIcon 
                                        icon={solid("caret-down")} 
                                        style={{ 
                                            width: 'auto', 
                                            height: '2vh',
                                            color: "rgba(255, 255, 255, 0.9)",
                                            transform:  isBankDropdownOpen ? 'rotate(180deg)' : "none",
                                            transition: 'transform 0.5s', 
                                            verticalAlign: "center",
                                        }}
                                    /> 
                                </div>
                            </div>
                </DropDown>
            </div>
        </div>
    );
};

export default AccountSelection;
